import {Vue, Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import Log from '@/components/Log';
import './style.less';

interface IModal {
  data?: object;
}

@Component
export default class ImgModal extends tsx.Component<IModal> {
  
  @Prop() public data?: object
  
  render() {
    const { data } = this.$props;
    console.log(data);
    return data.visible ?  (
      <div class='modal-container'>
        <Log type='hooks' number='H021' />
        <img class='modal-message' style={`background: url(${data.imageUrl});background-size: 100% 100%;`}  />
        <img onClick={data.onClose} class='modal-close' src={require('@/assets/svg/close.svg')} />
      </div>
    ) : null
  }
  
}